import { Box, styled, Typography, typographyClasses } from '@mui/joy';

interface IWrapperProps {
  hasBackground?: boolean;
}

interface ILabelProps {
  truncateLabel?: boolean;
}

const wrapperPropsToSkip: PropertyKey[] = ['hasBackground'];
const wrapperShouldForwardProp = (propName: PropertyKey) => !wrapperPropsToSkip.includes(propName);

const labelPropsToSkip: PropertyKey[] = ['truncateLabel'];
const labelShouldForwardProp = (propName: PropertyKey) => !labelPropsToSkip.includes(propName);

export const LineWrapper = styled(Box, {
  shouldForwardProp: wrapperShouldForwardProp,
})<IWrapperProps>(({ theme, hasBackground }) => ({
  display: 'flex',
  padding: '12px 8px',
  backgroundColor: hasBackground ? theme.palette.background.level1 : 'inherit',
  borderRadius: 6,
}));

export const LabelWrapper = styled(Typography, {
  shouldForwardProp: labelShouldForwardProp,
})<ILabelProps>(({ theme, truncateLabel }) => ({
  color: theme.palette.neutral[700],
  fontSize: 14,
  fontWeight: 500,
  // Opt-in single-line label truncation for narrow containers (e.g. InfoCard rows).
  // Off by default so callers that pack Lines horizontally (e.g. UomDetails) keep full labels.
  ...(truncateLabel && {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
    maxWidth: '60%',
  }),
}));

export const ValueWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  textAlign: 'right',
  flexWrap: 'wrap',
  overflowWrap: 'break-word',
  maxWidth: '85%',
  // Allow flex child to shrink below content's intrinsic width so children with
  // `text-overflow: ellipsis` can truncate instead of pushing the layout.
  minWidth: 0,
  fontSize: 14,
  fontWeight: 600,

  [`& .${typographyClasses.root}`]: {
    fontSize: 14,

    '& svg': {
      fontSize: 26,
    },
  },
});
